module.exports = __webpack_public_path__ + "static/img/back.fe8419cd.png";